import React, { useEffect, useRef, useState } from "react"
import GUI, { IGUIProps } from "../GUI"

export type TVResizerProps = IGUIProps & {
    position?:"start"|"end"
    min:number
    max:number
    children:React.ReactNode
}

export default function(props:TVResizerProps){
    const [width,setWidth] = useState<number>(0)
    const self = useRef<HTMLDivElement|null>(null)
    const w = useRef<number>(0)
    const x = useRef<number>(0)

    const position = props.position || "end"
    const onDown = (e:React.PointerEvent) => {
        e.preventDefault()
        x.current = e.clientX;
        w.current = width
        document.addEventListener("pointerup", onUp)
        document.addEventListener("pointermove", onMove)
    }
    const onMove = (e:PointerEvent) => setWidth(_ => Math.max(Math.min(w.current + e.clientX - x.current, props.max), props.min))
    const onUp = () => {
        document.removeEventListener("pointerup", onUp)
        document.removeEventListener("pointermove", onMove)
    }

    useEffect(() => {
        self.current && setWidth(self.current.clientWidth)
    }, [])

    const style = width ? {width:width+"px",minWidth:width+"px"} : {}

    return <div className={GUI.joinClass("resizer", props.className)} ref={self} style={style}>
        {props.children}
        <div className={GUI.joinClass("divider", position)} onPointerDown={onDown}></div>
    </div>
}